import * as React from 'react';
import { cva } from 'class-variance-authority';
import { XIcon } from 'lucide-react';
import { Search } from './Icons';
import { cn } from '../lib/utils';
const searchInputVariants = cva('flex rounded-4xl py-4 px-5 md:py-[18px] pl-14 md:pl-20 md:text-xl xl:pt-6 xl:pb-5 xl:text-2xl font-normal w-full ring-offset-black file:bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', {
    variants: {
        variant: {
            default: 'bg-brand-grey text-black placeholder:text-black',
            white: 'bg-white text-black placeholder-neutral-950 file:bg-neutral-950',
            narrow: 'bg-brand-grey text-black placeholder:text-grayscale-gray40 py-3 md:py-3 xl:py-3.5 text-xs md:text-xs xl:text-base pl-[38px] md:pl-[38px] xl:pl-[70px]',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
const SearchInput = ({ className, containerClassName, variant, onChange, onKeyUp, ...props }) => {
    const ref = React.useRef(null);
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            ref.current?.blur();
        }
    };
    const handleKeyUp = (event) => {
        if (onKeyUp) {
            onKeyUp(event);
        }
    };
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
    };
    const handleClear = () => {
        handleChange({ target: { ...ref.current, value: '' } });
        ref.current?.focus();
    };
    return (React.createElement("div", { className: cn('relative', variant === 'narrow' && '[&>div>svg]:w-5 [&>div>svg]:h-5 [&>div]:pl-3 [&>div]:xl:pl-6', containerClassName) },
        React.createElement("div", { className: "absolute inset-y-0 flex items-center pl-3.5 md:pl-8" },
            React.createElement(Search, { "aria-label": "Search Icon", className: "pointer-events-none text-brand-navy" })),
        React.createElement("input", { ref: ref, type: "search", "aria-label": props['aria-label'] || 'Search the site', className: cn(searchInputVariants({ variant }), props.value && 'pr-[70px] md:pr-28 xl:pr-[118px]', className), onChange: handleChange, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, ...props }),
        props.value && (React.createElement("div", { className: cn('absolute inset-y-0 right-0 flex items-center', variant === 'narrow' ? 'pr-6 md:pr-12' : 'pr-3.5 md:pr-8 xl:pr-12') },
            React.createElement("button", { type: "button", className: cn('flex gap-0.5 md:gap-1.5 items-center font-normal text-black text-base', variant === 'narrow' ? 'text-sm md:text-sm' : 'md:text-xl'), onClick: handleClear },
                React.createElement(XIcon, { strokeWidth: "3", className: "size-3.5 md:size-5 text-gray-500", "aria-label": "Clear" }),
                ' ',
                "Clear")))));
};
SearchInput.displayName = 'SearchInput';
export { SearchInput };
